import { render, staticRenderFns } from "./RightSideModal.vue?vue&type=template&id=3253d3af&"
import script from "./RightSideModal.vue?vue&type=script&lang=js&"
export * from "./RightSideModal.vue?vue&type=script&lang=js&"
import style0 from "./RightSideModal.vue?vue&type=style&index=0&id=3253d3af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports